import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import HeartOutlined from '@ant-design/icons/HeartOutlined';

const cultura = {
  id: 'group-cultura',
  title: 'Cultura',
  type: 'group',
  children: [
    {
      id: 'back-to-core',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'pesquisas-clima',
      title: 'Pesquisas de clima',
      type: 'item',
      url: '/cultura/pesquisas-clima',
      icon: HeartOutlined,
      permissions: ['cultura.pesquisas-clima.view'],
      breadcrumbs: false
    }
  ]
};

export default cultura;
